<template>
  <div class="b1">
    <div class="flex_between_nowrap">
      <span class="title_before side_title">处置管理</span>
    </div>
    <div style="padding:0px 20px 0px 24px">
      <div
        class="flex_between_nowrap"
        style="margin-top:20px;margin-bottom:30px"
      >
        <div>
          <el-input
            clearable
            placeholder="请输入单号/组织/使用人"
            size="small"
            v-model="params['search']"
            style="width:300px;"
          >
            <i
              slot="suffix"
              class="el-icon-search inputIcon "
              @click.stop="tableSearch"
            ></i>
          </el-input>
        </div>
        <div class="flex_end">
          <el-button type="submit" @click="add_click">新增</el-button>
        </div>
      </div>
      <x-table url="/pc/operate/dispose/page" ref="xTable" :params="params">
        <el-table-column
          :label="item.label"
          :prop="item.model"
          show-overflow-tooltip
          v-for="item in columnArr"
          :key="item.model"
          ><template slot-scope="scope">
            <div style="width:100%" v-if="item.model == 'orderStatus'">
              <el-tag
                :style="assetStatusFulter(scope.row[item.model], false)"
                >{{ assetStatusFulter(scope.row[item.model], true) }}</el-tag
              >
            </div>
              <span
              @click="global_detals(scope.row.id)"
              style=" text-decoration:underline;cursor:pointer"
              v-else-if="item.model == 'assetCode' || item.model == 'assetName'"
              >{{ scope.row[item.model] }}</span
            >
            <span v-else>{{ scope.row[item.model] }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="addColor"
              @click="revoke(scope.row.id)"
              v-show="scope.row.orderStatus == 'await'"
              >撤销</el-button
            >
            <el-button
              type="text"
              class="addColor"
              @click="edit_click(scope.row)"
              v-show="scope.row.orderStatus == 'refuse'"
              >重新提交</el-button
            >                  <el-button
              type="text"
              class="addColor"
              @click="examine_details(scope.row,'dispose')"
              >详情</el-button
            >

            <!-- v-show="scope.row.orderStatus!=='pass'&&scope.row.orderStatus!=='apass'" -->

            <!-- 审核拒绝下才能出现提交 -->

            <!-- 删除 任务取消或者拒绝的时候 -->
            <el-button
              type="text"
              v-show="
                scope.row.orderStatus == 'cancel' ||
                  scope.row.orderStatus == 'refuse'
              "
              @click="
                $axiosDelete(
                  '/pc/operate/del',
                  { id: scope.row.id },
                  tableSearch,
                  '',
                  true
                )
              "
              class="deleteColor"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </x-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      params: {},

      columnArr: [
        {
          label: "状态",
          model: "orderStatus",
        },
        {
          label: "单号",
          model: "orderNo",
        },
        {
          label: "资产数量",
          model: "assetNum",
        },
        {
          label: "处置类型",
          model: "disposeType",
        },

        {
          label: "处置费用",
          model: "price",
        },
        {
          label: "处置日期",
          model: "startTime",
        },
        {
          label: "申请人",
          model: "createName",
        },
        {
          label: "申请时间",
          model: "createTime",
        },
        {
          label: "备注",
          model: "remark",
        },
        {
          label: "审批人",
          model: "examineName",
        },
        {
          label: "审批时间",
          model: "examineTime",
        },
        {
          label: "审批备注",
          model: "examineRemark",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    add_click() {
      this.$createDialog(this, {
        dialogConfig: { title: "资产处置新增", width: "860px" },
        namespace: "asset_dispose_add",
        whetherDestruction: true,

        assemblyConfig: {
          callBack: this.tableSearch,
        },
      });
    },
    edit_click(row) {
      this.$createDialog(this, {
        dialogConfig: { title: "资产处置--重新提交", width: "860px" },
        namespace: "asset_dispose_edit",
        whetherDestruction: true,

        assemblyConfig: {
          newId:row.id,
          ids: row.inJson.ids,
          changeData: row.asset,
          callBack: this.tableSearch,
          defaultRow: row.inJson,
        },
      });
    },
    assetStatusFulter(data, flag) {
      let str = "";
      if (flag) {
        switch (data) {
          case "await":
            str = "待审";

            break;

          case "pass":
            str = "同意";

            break;
          case "apass":
            str = "通过";

            break;
          case "cancel":
            str = "取消";

            break;
          case "refuse":
            str = "拒绝";

            break;
        }
      } else {
        switch (data) {
          case "pass":
            str = "color:#436bff;background:#d8e6ff;";

            break;
          case "await":
            str = "color:#436bff;background:#d8e6ff;";

            break;
          case "apass":
            str = "color:#42b983;background:#f0f9eb;";

            break;

          case "cancel":
            str = "color:#e0e0e0;background:#7c7c7c;";

            break;
          case "refuse":
            str = "color:#ffd0cc;background:#fa675c;";
            break;
        }
      }
      return str;
    },
    revoke(id) {
      this.$alertMsg.confirm("即将撤销申请,是否继续？", () => {
        this.$requestAxios(
          {
            url: "/pc/operate/repeal",
            data: { id },
          },
          (data) => {
            this.$success();
            this.tableSearch();
          }
        );
      });
    },
    tableSearch() {
      this.$refs.xTable.search();
    },
  },
};
</script>
<style scoped></style>
